import { Settings, WidgetData } from './data'
import { Widget } from './widget'

import parse from 'html-react-parser'
import * as cheerio from 'cheerio'

export type TextEditorData = WidgetData & {
  settings: Settings & {
    editor?: string
  }
  widgetType: 'text-editor'
}

export class TextEditorWidget extends Widget {
  content: string | null /* the raw HTML content of the Text Editor */

  constructor (data: TextEditorData) {
    super(data)
    this.content = data.settings.editor ?? null
  }

  /**
   * Parses the raw, potentially HTML content and returns React elements that can be used in JSX.
   */
  parse = (): null | string | JSX.Element | JSX.Element[] => {
    if (this.content !== null) return parse(this.content)
    else return null
  }

  /**
   * Parses the raw, potentially HTML content and returns any text contained within.
   */
  text = (): string => {
    if (this.content !== null) {
      // https://cheerio.js.org/docs/api/functions/load
      // According to the docs there is a third allowed parameter. Their typescript definitions must be incorrect.
      const $ = cheerio.load(this.content, {}, false /* fragment */)
      return $.root().text()
    } else {
      return ''
    }
  }
}
